import PropTypes from 'prop-types'
import { Element } from './html/element'

export const ExternalLink = ({
  children,
  href,
  isDynamicReport,
  ...others
}) => {
  return (
    <Element
      elementName="a"
      href={href.startsWith('http') ? href : 'http://' + href}
      target="_blank"
      rel="noreferrer"
      className="cursorPointer"
      style={{
        color: isDynamicReport ? '' : !href ? '#9C9C9C' : '#2C73E8',
        pointerEvents: !href ? 'none' : 'auto',
      }}
      {...others}
    >
      {children}
    </Element>
  )
}

ExternalLink.propTypes = {
  children: PropTypes.any,
  href: PropTypes.string.isRequired,
}

ExternalLink.defaultProps = {
  href: '',
}
